type NotificationType = 'paymentsDone' | 'sharedDocuments';

const checkNotificationFreshness = (
  onDashboard: boolean,
  contractId: number,
  notificationType: NotificationType
) => {
  const clickedNotifications = localStorage.getItem(notificationType);
  if (clickedNotifications) {
    const isCurrentNotificationClicked =
      JSON.parse(clickedNotifications).includes(contractId);
    return onDashboard && !isCurrentNotificationClicked;
  }
  return onDashboard;
};

export default checkNotificationFreshness;
